import { connect } from 'react-redux'

import FieldEditView from '../../components/FieldsComponents/FieldEditView'

const mapStateToProps = state => ({})

export default connect(mapStateToProps)(FieldEditView)
